<template>
        <div class="xia-1">
            <div class="w1200" style="padding:40px 0 0 30px;">
                    <div style="font-size: 24px;color: #FFFFFF;text-align: center;">业务咨询</div>
                    <div style="margin-left: 20%;">
                        <img src="/static/zixun.png" style="float: left;width: 22px;margin-top: 4px;">
                        <div style="font-size: 20px;color: #FFFFFF;letter-spacing: 0;text-align: center;line-height: 40px;float:left;width:680px">上述产品为股东方旗下产品，如有业务需求可详询中国银行客服电话95566，或咨询全国各地中国银行营业机构。</div>
                    </div>
            </div>
        </div> 
</template>
<script>
export default {
	name: 'gylfooter2',
	props: {
        act:{
            type:String,
            default:''
        },
	},
	data() {
		return {
            topFixed:false,
            scrollTop:null
		}
    },
	created(){
        // if(this.$store.state.menu.scroll>375){//解决滚动后再点击切换其他tab的bug，且必须写在created里避免闪烁
        //     this.topFixed = true;
        // }else{
        //     this.topFixed = false;
        // }
    },
    mounted(){
        //window.addEventListener('scroll',this.handleScroll)
    },
	methods: {
        // handleScroll(e){
        //     this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        //     this.$store.commit("setScroll",this.scrollTop);
        //     if(this.$store.state.menu.scroll>375){
        //         this.topFixed = true;
        //     }else{
        //         this.topFixed = false;
        //     }
        // },
        // zhwy(){
        //     window.location.href='https://ebsnew.boc.cn/boccp/login.html?entryType=9';
        // }
	}
}
</script>
<style scoped>
.xia-1{height: 2.2rem;clear: both;background-image: url(/static/bottom.png);background-size: 100% 100%;background-position: left top;background-repeat: no-repeat;}
.xia-quyu{padding-top: .48rem; float: left;}
.xia-zi1{font-size: 14px;color:#fff;}
.xia-zi2{font-size: 14px;color:#fff;margin-top: 20px;position: absolute}
.xia-zi2 img{width: 14px;}
.xia-zi2 span{display: inline-block;margin-left: 20px;}
</style>


// WEBPACK FOOTER //
// src/components/inc/component/gyl-footer2.vue